(function(){
'use strict';
var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var $=function(s,c){return(c||document).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
var CUT=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cutoff-hour'),10)||15;
function post(u,b){return fetch(R+u,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(b)}).then(function(r){return r.json()})}

/* ---------- Cart drawer ---------- */
function drawer(){return $('[data-drawer]')}
function openCart(){var d=drawer();if(!d)return;d.classList.add('open');d.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}
function closeCart(){var d=drawer();if(!d)return;d.classList.remove('open');d.setAttribute('aria-hidden','true');document.body.style.overflow=''}
function refresh(open){
  return fetch(R+'?sections=cart-drawer').then(function(r){return r.json()}).then(function(j){
    var tmp=document.createElement('div');tmp.innerHTML=j['cart-drawer'];
    var nd=$('[data-drawer]',tmp),od=drawer();
    if(od&&nd){var was=od.classList.contains('open');od.replaceWith(nd);if(was||open){nd.classList.add('open');nd.setAttribute('aria-hidden','false')}}
    return fetch(R+'cart.js').then(function(r){return r.json()}).then(function(c){$$('[data-cart-count]').forEach(function(e){e.textContent=c.item_count})});
  }).then(tick);
}
function add(id,qty){
  return post('cart/add.js',{items:[{id:id,quantity:qty||1}]}).then(function(r){
    if(r&&r.status){alert(r.description||r.message);return}
    return refresh(true);
  });
}
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-add],[data-cart-open],[data-cart-close],[data-line]');
  if(!t)return;
  if(t.hasAttribute('data-cart-open')&&drawer()){e.preventDefault();refresh(true)}
  else if(t.hasAttribute('data-cart-close')){closeCart()}
  else if(t.hasAttribute('data-add')){e.preventDefault();t.disabled=true;add(parseInt(t.getAttribute('data-add'),10)).then(function(){t.disabled=false},function(){t.disabled=false})}
  else if(t.hasAttribute('data-line')){post('cart/change.js',{line:parseInt(t.dataset.line,10),quantity:parseInt(t.dataset.to,10)}).then(function(){refresh()})}
});
document.addEventListener('change',function(e){
  if(e.target.matches('[data-gift]')){post('cart/update.js',{attributes:{'Grußkarte':e.target.checked?'Ja':''}})}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});


/* ---------- Burger-Menü ---------- */
function menu(){return $('[data-mdrawer]')}
function setMenu(on){var m=menu();if(!m)return;m.classList.toggle('open',on);m.setAttribute('aria-hidden',on?'false':'true');document.body.style.overflow=on?'hidden':''}
document.addEventListener('click',function(e){
  if(e.target.closest('[data-menu-open]')){setMenu(true)}
  else if(e.target.closest('[data-menu-close]')){setMenu(false)}
  else if(e.target.closest('.mdrawer__nav a')){setMenu(false)}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false)});

/* ---------- Slider (Touch-Swipe, Pfeile am Desktop, Zähler) ---------- */
function initSliders(){
  $$('[data-slider]').forEach(function(sl){
    if(sl.__sn)return;sl.__sn=1;
    var tr=$('[data-slider-track]',sl),pv=$('[data-slider-prev]',sl),nx=$('[data-slider-next]',sl),ct=$('[data-slider-count]',sl);
    if(!tr)return;
    function state(){
      var max=tr.scrollWidth-tr.clientWidth-2,x=tr.scrollLeft;
      var scrollable=max>0;
      if(pv){pv.hidden=!scrollable||x<=2;if(pv.closest('.pgal__ctl'))pv.disabled=x<=2}
      if(nx){nx.hidden=!scrollable||x>=max;if(nx.closest('.pgal__ctl'))nx.disabled=x>=max}
      if(ct){var w=tr.clientWidth||1,n=tr.children.length,i=Math.min(n,Math.round(x/w)+1);ct.textContent=i+' / '+n}
    }
    function go(d){tr.scrollBy({left:d*tr.clientWidth*(ct?1:.85),behavior:'smooth'})}
    if(pv)pv.addEventListener('click',function(){go(-1)});
    if(nx)nx.addEventListener('click',function(){go(1)});
    tr.addEventListener('scroll',function(){window.requestAnimationFrame(state)},{passive:true});
    window.addEventListener('resize',state);
    state();setTimeout(state,400);
    $$('img',tr).forEach(function(im){if(!im.complete)im.addEventListener('load',state)});
  });
}
initSliders();
document.addEventListener('shopify:section:load',initSliders);

/* ---------- Product page ---------- */
var P=$('[data-product]');
if(P){
  var V=JSON.parse($('[data-variants]',P).textContent),form=$('[data-pdp-form]',P),vid=$('[data-vid]',P),qty=$('[data-qty]',P),btn=$('[data-atc]',P);
  function cur(){var o=$$('[data-option]',P).map(function(s){return s.value});return V.filter(function(v){return v.options.join('|')===o.join('|')})[0]}
  function upd(){
    var v=cur(),pr=$('[data-price]',P);if(!v)return;
    vid.value=v.id;
    if(pr)pr.innerHTML=(v.compare?'<s>'+v.compare+'</s> <b class="sale">'+v.price+'</b>':'<b>'+v.price+'</b>');
    $('[data-stock-text]',P).textContent=v.available?'Auf Lager':'Aktuell nicht verfügbar';
    var q=$('[data-stock-qty]',P);if(q){q.textContent=v.available&&v.qty>0?'nur noch '+v.qty+' Stück':''}
    btn.disabled=!v.available;btn.textContent=v.available?'In den Warenkorb':'Ausverkauft';
    history.replaceState(null,'','?variant='+v.id);
  }
  P.addEventListener('change',function(e){if(e.target.matches('[data-option]'))upd()});
  P.addEventListener('click',function(e){var b=e.target.closest('[data-q]');if(b){qty.value=Math.max(1,(parseInt(qty.value,10)||1)+parseInt(b.dataset.q,10))}});
  form.addEventListener('submit',function(e){e.preventDefault();btn.disabled=true;add(parseInt(vid.value,10),parseInt(qty.value,10)||1).then(function(){btn.disabled=false},function(){btn.disabled=false})});
}

/* ---------- Cut-off timer (Europe/Berlin) ---------- */
var fmt=new Intl.DateTimeFormat('de-DE',{timeZone:'Europe/Berlin',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23',weekday:'short'});
function berlin(){var o={};fmt.formatToParts(new Date()).forEach(function(p){o[p.type]=p.value});return{h:+o.hour,m:+o.minute,s:+o.second,wd:o.weekday}}
function pad(n){return n<10?'0'+n:''+n}
function tick(){
  var b=berlin(),left=CUT*3600-(b.h*3600+b.m*60+b.s),before=left>0;
  if(!before)left+=86400;
  var txt=pad(Math.floor(left/3600))+':'+pad(Math.floor(left%3600/60))+':'+pad(left%60);
  $$('[data-cutoff]').forEach(function(el){
    $('[data-cutoff-time]',el).textContent=txt;
    $('[data-cutoff-label]',el).textContent=before?'Bestelle in':'Bestelle in';
    var l=$('[data-cutoff-label]',el);l.textContent=before?'Bestelle in':'Neues Zeitfenster – bestelle in';
    var s=el.querySelector('.cutoff__s');if(!s){s=document.createElement('span');s.className='cutoff__s';el.lastElementChild.appendChild(s)}
    s.textContent=before?' – Versand heute!':' – Versand morgen';
  });
  var days=['So','Mo','Di','Mi','Do','Fr','Sa'],names={Mo:'Montag',Di:'Dienstag',Mi:'Mittwoch',Do:'Donnerstag',Fr:'Freitag',Sa:'Samstag',So:'Sonntag'};
  var idx=days.indexOf(b.wd.replace('.','')),ship=before?0:1,d=idx+ship;
  function bump(i){while(i%7===0||i%7===6)i++;return i}
  var send=bump(d),arr=bump(send+1);
  $$('[data-delivery]').forEach(function(e){e.textContent='bis '+names[days[arr%7]]+' bei dir'});
}
tick();setInterval(tick,1000);

/* ---------- Zuletzt angesehen (echt, nur lokal im Browser) ---------- */
(function(){
  var h=$('[data-handle]'),box=$('[data-recent]');if(!box)return;
  var L=[];try{L=JSON.parse(localStorage.getItem('sn_recent')||'[]')}catch(e){}
  var cur=h&&h.dataset.handle;
  var show=L.filter(function(x){return x!==cur}).slice(0,4);
  if(cur){L=[cur].concat(L.filter(function(x){return x!==cur})).slice(0,8);try{localStorage.setItem('sn_recent',JSON.stringify(L))}catch(e){}}
  if(!show.length)return;
  Promise.all(show.map(function(x){return fetch(R+'products/'+x+'.js').then(function(r){return r.ok?r.json():null})})).then(function(a){
    var l=$('[data-recent-list]'),n=0;
    a.forEach(function(p){if(!p)return;n++;
      var img=p.featured_image?'<img src="'+p.featured_image.replace(/(\.\w+)(\?|$)/,'_360x$1$2')+'" alt="" loading="lazy">':'<span class="ph">🍬</span>';
      var c=document.createElement('article');c.className='card';
      c.innerHTML='<a class="card__img" href="'+p.url+'">'+img+'</a><h3 class="card__t"><a href="'+p.url+'">'+p.title+'</a></h3><div class="card__p"><b>'+(p.price/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'})+'</b></div>';
      l.appendChild(c)});
    if(n)box.hidden=false;
  });
})();

/* ---------- Passwort-Countdown ---------- */
var C=$('[data-countdown]');
if(C){
  var T=new Date(C.dataset.countdown).getTime();
  (function loop(){
    var d=Math.max(0,T-Date.now())/1000;
    $('[data-d]',C).textContent=pad(Math.floor(d/86400));$('[data-h]',C).textContent=pad(Math.floor(d%86400/3600));
    $('[data-m]',C).textContent=pad(Math.floor(d%3600/60));$('[data-s]',C).textContent=pad(Math.floor(d%60));
    setTimeout(loop,1000);
  })();
}
})();
